module.exports = __webpack_public_path__ + "static/media/SBT21concept.2fc0d14f.jpg";